import profile from './profile';
import settings from './settings';

export default {
  chats: {
    title: 'Чаты',
    search: {
      placeholder: 'Поиск сообщений или пользователей',
    },
  },
  profile,
  settings,
}
